import IconDelivery from '@icons/box.svg';
import IconExpressDelivery from '@icons/express-delivery.svg';
import IconPickup from '@icons/point.svg';

import type { ValueOf } from '@/utils/types/value-of';

export const DELIVERY_SELECTOR_TYPES = {
  courier: 'courier',
  pickup: 'pickup',
  express: 'express',
} as const;

export const WIDGET_PLACES = {
  checkout: 'checkout',
  courier: 'courier',
  express: 'express',
  pickup: 'pickup',
  storeCard: 'storeCard',
} as const;

export const WIDGET_TYPES = {
  stub: 'stub',
  onlyOneStore: 'onlyOneStore',
  oneStore: 'oneStore',
  oneOrder: 'oneOrder',
  courier: 'courier',
} as const;

export type TViewTypeKeys = ValueOf<typeof DELIVERY_SELECTOR_TYPES>;

type TViewType = Record<TViewTypeKeys, {
  value: TViewTypeKeys;
  icon: string;
  label: string;
}>;

export const viewTypeItems: TViewType = {
  courier: {
    value: DELIVERY_SELECTOR_TYPES.courier,
    icon: IconDelivery,
    label: 'Курьером',
  },
  express: {
    value: DELIVERY_SELECTOR_TYPES.express,
    icon: IconExpressDelivery,
    label: 'Экспресс',
  },
  pickup: {
    value: DELIVERY_SELECTOR_TYPES.pickup,
    icon: IconPickup,
    label: 'Самовывоз',
  },
} as const;
